import React from "react";
import getCopyright from "../../../lib/copyright";

const Footer = () => {
  const copyright = getCopyright();
  return <div className={"vcl-footer"}>{copyright}</div>;
};

export default Footer;
